import styles from "./BundleDescriptionIcons.module.scss";
import { RetiredStaticBundleComponentParent } from "../../../../types/types";

type IconDetailsProps = {
  text: string;
  iconUrl: string;
};

const IconDetails = ({ text, iconUrl }: IconDetailsProps) => (
  <>
    <span
      className={styles.text}
      data-testid="bundleProductDescription:icons:text"
    >
      {text}
    </span>
    <img
      className={styles.image}
      data-testid="bundleProductDescription:icons:image"
      src={iconUrl}
      alt="an icon"
    />
  </>
);

type Props = {
  product: RetiredStaticBundleComponentParent;
};

type Icon = {
  text: string;
  iconUrl: string;
  linkUrl?: string | null | undefined;
};

export const BundleDescriptionIcons = ({ product }: Props) => {
  const { icons = [] } = product;

  const hasIcons = icons.length > 0;

  if (!hasIcons) return null;

  return (
    <>
      BundleDescriptionIcons
      <ul data-testid="bundleProductDescription:icons" className={styles.icons}>
        {icons.map(({ text, iconUrl, linkUrl }: Icon) => (
          <li key={iconUrl} className={styles.icon}>
            {linkUrl ? (
              <a
                aria-label={text}
                className={styles.link}
                data-testid="bundleProductDescription:icons:link"
                href={linkUrl}
              >
                <IconDetails text={text} iconUrl={iconUrl} />
              </a>
            ) : (
              <IconDetails text={text} iconUrl={iconUrl} />
            )}
          </li>
        ))}
      </ul>
    </>
  );
};
